import { ChangeDetectionStrategy, Component, signal } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h1 class="e11-text-skin-primary-accent">{{ 'Woops...' | translate }} {{ title() | translate }}</h1>
    <e11-panel>
      <div class="e11-my-16 e11-text-center">
        <h1 class="e11-text-skin-light e11-text-6xl">4<span class="material-icons-outlined e11-text-5xl"> sentiment_dissatisfied </span>4</h1>
        <h3 class="e11-mb-8">{{ 'Page not found' | translate }}</h3>
        <p>{{ message() | translate }}</p>
      </div>
    </e11-panel>
  `,
})
export class FileNotFoundComponent {
  title = signal("That page wasn't found")
  message = signal('It appears the page you are looking for is unavailable.')

  getCurrentNavigationState() {
    const navigation = this.router.getCurrentNavigation()
    return navigation?.extras.state ?? history.state
  }

  constructor(private router: Router) {
    const { title, message } = this.getCurrentNavigationState()
    if (title) this.title.set(title)
    if (message) this.message.set(message)
  }
}
